import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import JsonLd from '@/components/base/JsonLd';
import { getHomepageSchema, getOrganizationSchema, getBreadcrumbSchema } from '@/data/schema';
import Hero from './components/Hero';
import CategorySection from './components/CategorySection';
import ComparisonSection from './components/ComparisonSection';
import HowItWorks from './components/HowItWorks';
import ArticleCards from './components/ArticleCards';
import AboutSection from './components/AboutSection';
import CTASection from './components/CTASection';
import TrustSection from './components/TrustSection';

export default function Home() {
  return (
    <main>
      <JsonLd data={getHomepageSchema()} />
      <JsonLd data={getOrganizationSchema()} />
      <JsonLd data={getBreadcrumbSchema([
        { name: 'Home', url: '/' },
      ])} />
      <Navbar />
      <Hero />
      <CategorySection />
      <ComparisonSection />
      <HowItWorks />
      <ArticleCards />
      <AboutSection />
      <CTASection />
      <TrustSection />
      <Footer />
    </main>
  );
}